import React from "react";
import PropTypes from "prop-types";
import Heading from "../../elements/heading";
import IconLink from "../../elements/icon-link";
import BodyText from "../../elements/body-text";
import classNames from "classnames";

import "./style.scss";

export default function MyCasesSection({ heading, body, cases, noCase }) {
  return (
    <div className="my-cases-section">
      <div className="my-cases-section-heading">
        <Heading type={heading.type} html={heading.html} typographyClass={heading.typographyClass || "type-h3"} />
      </div>
      <BodyText {...body} />
      {cases &&
        cases.map(item => {
          const statusClasses = classNames("status", {
            active: item.active,
            closed: item.closed
          });
          return (
            <div className="my-cases" key={item.heading.html.value}>
              <div className="case-heading">
                <Heading {...item.heading} className="title" />
                <BodyText className={statusClasses} html={item.status} />
              </div>
              {body.html && <BodyText {...item.body} />}
              <IconLink {...item.link} />
            </div>
          );
        })}
      {noCase && (
        <div className="my-cases no-case">
          <div className="case-heading no-case">
            <Heading {...noCase.heading} className="no-case-title" />
          </div>
          <BodyText {...noCase.body} />
        </div>
      )}
    </div>
  );
}

MyCasesSection.propTypes = {
  heading: PropTypes.object,
  body: PropTypes.shape({
    html: PropTypes.string,
    className: PropTypes.string
  }),
  cases: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.object,
      body: PropTypes.object,
      link: PropTypes.object,
      active: PropTypes.bool,
      status: PropTypes.string,
      closed: PropTypes.bool
    })
  ),
  noCase: PropTypes.shape({
    heading: PropTypes.object,
    body: PropTypes.object
  })
};
